import * as React from "react";

import "./address-col.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {chain}          from "@Common/utils/fs";

import {SelectAddressModal} from "../../common/select-address-modal/select-address-modal";
import {setShippingAddress} from "../../../store/actions/shipping/set-shipping-address";

export const AddressCol = ({myAddresses, officeAddress, store, apiError, next}) => cs(
    ["getAddress", (_, next) => next((id) => {
        if (officeAddress.value && officeAddress.value.idPrimary === id) {
            return officeAddress.value;
        }
        return myAddresses.value?.find((a) => a.idPrimary === id);
    })],
    ({getAddress}) => next({
        isInvalid: (item) => !item.shipping?.addressId || !getAddress(item.shipping.addressId),
        render: ({item}) => cs(
            ["onChangeAddressId", ({}, next) => cs(
                consumeContext("apis"),
                consumeContext("userLevels"),
                ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
                ({isInternalUser, apis}) => next(async (addressId) => {
                    try {
                        await store.dispatch(setShippingAddress(addressId, {itemId: item.itemId, apis, apiError, isInternalUser}));
                    } catch (e) {
                        alert("Sorry we got an API error" + chain(e?.errors?.msg, (_) => _ ? ": " + _ : ""));
                    }
                }),
            )],
            ["address", ({}, next) => next(item.shipping && getAddress(item.shipping.addressId))],
            ({onChangeAddressId, address}) => (
                <div className="address-col-9z5">
                    {apiError.value ? (
                        <div className="error">
                            {apiError.value}
                        </div>
                    ) : !item.shipping?.addressId ? (
                        <div className="error">
                            No address selected
                        </div>
                    ) : !address ? (
                        <div className="error">
                            Selected address unavailable. Please select another address.
                        </div>
                    ) : <>
                        <div className="name" xd-qa-type="label" xd-qa-name={`Shipping Address Name ${item.itemId}`}>
                            {address?.contactName}
                        </div>
                        <div className="address" xd-qa-type="label" xd-qa-name={`Shipping Address ${item.itemId}`}>
                            {address?.address1}
                        </div>
                        {address?.address2 && (
                            <div className="address" xd-qa-type="label" xd-qa-name={`Shipping Address address2 ${item.itemId}`}>
                                {address?.address2}
                            </div>
                        )}
                    </>}
                    <div className="actions">
                        {cs(
                            ["selectAddressModal", ({}, next) => SelectAddressModal({
                                selectedAddressId: item.shipping?.addressId,
                                myAddresses, officeAddress,
                                next,
                            })],
                            ({selectAddressModal}) => (
                                <a
                                    onClick={() => {
                                        selectAddressModal.show({
                                            onChangeAddressId,
                                        });
                                    }}
                                    xd-qa-type="link"
                                    xd-qa-name={`Edit Shipping Address ${item.itemId}`}
                                >Edit</a>
                            )
                        )}
                    </div>
                </div>
            ),
        ),
    }),
);
